import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Button, Select } from "components";
import {
  CompanyName,
  GroupButton,
  Question,
  WrapperConfirmForm,
  WrapperSelectLanguage,
} from "./UserBusiness.style";
import { settingDataResponse } from "redux/setting/settingData/settingDataStates";
import { useSelector } from "react-redux";
import { languageName } from "screens/setting/constant";

const ConfirmForm: React.FC = () => {
  const { t }: any = useTranslation("translation", {
    keyPrefix: "body-temperature",
  });
  const { t: t1 }: any = useTranslation("translation", {
    keyPrefix: "user-list",
  });
  const { t: t2 }: any = useTranslation("translation", {
    keyPrefix: "user-business",
  });

  const settingData = useSelector(settingDataResponse);
  const [isSelectLanguage, setIsSelectLanguage] = useState(false);

  const [languageOptions, setLanguageOptions] = useState();
  const [languageValue, setLanguageValue] = useState<number>();

  useEffect(() => {
    if (settingData && Object.keys(settingData.result).length) {
      const { temperature_managerment_info } = settingData?.result;

      const convertedLanguageOptions = languageName[
        temperature_managerment_info.app_language_id
      ].map((name: string, idx: number) => {
        return {
          id: idx + 1,
          value: idx + 1,
          name: name,
        };
      });
      convertedLanguageOptions.splice(2, convertedLanguageOptions.length);

      setLanguageOptions(convertedLanguageOptions);
      setLanguageValue(temperature_managerment_info.app_language_id);
    }
  }, [settingData]);

  return (
    <WrapperConfirmForm>
      <CompanyName>{t2("company-name")}</CompanyName>
      <Question style={{ marginBottom: isSelectLanguage ? 16 : 32 }}>
        {t2("confirm-question")}
      </Question>
      {isSelectLanguage && (
        <WrapperSelectLanguage>
          <div>{t2("select-language")}</div>
          <div
            style={{
              background: "white",
              borderRadius: 4,
              width: "fit-content",
              margin: "0 auto",
            }}
          >
            <Select
              value={languageValue}
              options={languageOptions}
              width="114px"
              onChange={(e: any) => setLanguageValue(e)}
            />
          </div>
        </WrapperSelectLanguage>
      )}
      <GroupButton>
        <Button
          name={t("no")}
          background="#FFFFFF"
          color="#666666"
          border="1px solid #CCCCCC"
          fontSize={16}
          fontWeight={700}
        />
        <Button
          name={t1("yes")}
          background="#2F8CAE"
          color="#FFFFFF"
          border="none"
          fontSize={16}
          fontWeight={700}
          onClick={() => setIsSelectLanguage(true)}
        />
      </GroupButton>
    </WrapperConfirmForm>
  );
};

export default ConfirmForm;
